export default __webpack_public_path__ + "static/media/l2-p6.84c3b770.svg";